import React from 'react';
import IcoMoon from 'react-icomoon';

const iconSet = require('./selection.json');

const Icon = ({ ...props }) => {
  let styles = {};
  if (props.size) {
    styles = {
      width: props.size,
      heigth: props.size,
    };
  }
  return <IcoMoon {...styles} iconSet={iconSet} {...props} />;
};

export default Icon;
